<template>
  <a-card title="Fasilitas Kerja" :loading="loading.page">
    <template slot="extra">
        <a-button v-if="isHRD && mode!='Ubah'" type="secondary" icon="edit" :loading="loading.save" :disabled="loading.page" @click="setubah">Ubah Data</a-button>
    </template>
    <a-row :gutter="0" type="flex" justify="start" align="stretch" v-if="mode=='Ubah'">
      <!-- Kolom kiri -->
      <a-col :xs="8" :lg="8">
        <a-form-model ref="form" :model="form" :rules="rules" class="h-full">
          <a-form-model-item label="" prop="fasilitas">
            <a-select @change="onSelectItem" showSearch allowClear v-model="form.fasilitas" placeholder="Pilih Fasilitas Kerja">
              <a-select-option v-for="item in dataSource.listFasilitas" :key="item.option">
                {{item.option}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-row :gutter="16" type="flex">
            <a-col :xs="24" :lg="16">
              <a-form-model-item v-if="inputVisible" label="Nilai Fasilitas" prop="nilai_fasilitas">
                <a-input-number
                  id="inputNumber"
                  :min="1"
                  :disabled="!inputVisible"
                  v-model="form.nilai_fasilitas"
                  class="w-full"
                />
                <!-- :formatter="rupiahFormatter"
                  :parser="rupiahParser" -->
              </a-form-model-item>
            </a-col>
            <a-col :xs="24" :lg="8">
              <a-form-model-item v-if="inputVisible" label="Satuan" prop="satuan">
                <a-select showSearch v-model="form.satuan" placeholder="Pilih Satuan Fasilitas">
                  <a-select-option v-for="item in dataSource.listSatuan" :key="item">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-form-model-item v-if="inputVisible" label="DPP" prop="is_dpp">
            <a-radio-group
              buttonStyle="solid"
              v-model="form.is_dpp"
            >
              <a-radio-button value="0">Tidak</a-radio-button>
              <a-radio-button value="1">Ya</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-form-model>
      </a-col>

      <!-- Kolom kanan -->
      <a-col :xs="8" :lg="8" class="flex flex-col justify-end">
        <a-button 
          type="primary" 
          icon="plus"
          :class="isMobile ? 'm-top' : 'm-left'" 
          :style="!isMobile ? 'margin-top: 4px;' : ''" 
          :loading="loading.save" 
          :disabled="loading.page" 
          @click="save"
        >
          Tambah
        </a-button>
      </a-col>
    </a-row>
    <a-table
      :rowKey="(record, index) => { return index.toString(); }"
      size="small"
      bordered
      class="m-top"
      :columns="columns"
      :dataSource="dataSource.daftarFasilitas"
      :loading="loading.table"
      :pagination="pagination"
    >
      <template slot="nomor" slot-scope="text,item,index">{{ index + 1 }}</template>
      <template slot="nama" slot-scope="item">{{ item.fasilitas }}</template>
      <!-- <template slot="nilai_fasilitas" slot-scope="item">{{ Number(item.nilai_fasilitas) > 0 ? formatRupiah(item.nilai_fasilitas) : item.nilai_fasilitas }}</template> -->
       <template slot="nilai_fasilitas" slot-scope="item">{{ item.nilai_fasilitas }} {{ item.satuan }}</template>
       <template slot="is_dpp" slot-scope="item">{{ item.is_dpp=="1"?'YA':'TIDAK' }}</template>
      <template slot="aksi" slot-scope="item">
        <a-button-group>
          <a-button type="danger" icon="close" @click="remove(item.id_fasilitas)"></a-button>
        </a-button-group>
      </template>
    </a-table>
  </a-card>
</template>
<script>
import { mapGetters } from 'vuex';
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name:"fasilitasKerja",
  props: ["data","tlc"],
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: {
        save: false,
        page: false,
        table: false,
      },
      mode: 'View',
      form: {
        fasilitas: null,
        nilai_fasilitas: null,
        satuan: null,
        is_dpp: "0"
      },
      dataSource: {
        daftarFasilitas: [],
        listFasilitas: [],
        listSatuan:[]
      },
      columns: [{
          title: "#",
          key: "nomor",
          align: "center",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },{
          title: "Nama Fasilitas Kerja",
          key: "nama",
          align: "left",
          scopedSlots: { customRender: "nama" },
        },{
          title: "Nilai Fasilitas",
          key: "nilai_fasilitas",
          align: "center",
          scopedSlots: { customRender: "nilai_fasilitas" },
        },{
          title: "DPP",
          key: "is_dpp",
          align: "center",
          scopedSlots: { customRender: "is_dpp" },
        },{
          title: "Aksi",
          key: "aksi",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "aksi" },
        },
      ],
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      inputVisible: false
    }
  },
  computed: {
    ...mapGetters(["getAuth"]),
    isHRD(){
      return this.$route.meta.isHRD
    },
    rules(){
      return {
        fasilitas: [
          {
            required: true,
            message: "Fasilitas kerja tidak boleh kosong!",
            trigger: "change",
          },
        ],
        nilai_fasilitas: [
          {
            required: this.inputVisible,
            message: "Nilai fasilitas kerja tidak boleh kosong!",
            trigger: "change",
          }
        ],
        satuan: [
          {
            required: this.inputVisible,
            message: "Satuan tidak boleh kosong!",
            trigger: "change",
          }
        ],
        is_dpp: [
          {
            required: this.inputVisible,
            message: "DPP tidak boleh kosong!",
            trigger: "change",
          }
        ]
      }
    }
  },
  mounted(){
    this.fetchData()
  },
  methods:{
    async fetchData(){
      this.loading.page = true
      const payload = {
        tlc: this.tlc
      }
      try {
        const response = await this.asyncAxiosGet("Master_karyawan/fasilitas", this.getAuth, payload);
        this.dataSource.daftarFasilitas = response.data
        this.dataSource.listFasilitas = response.fasilitas
        this.dataSource.listSatuan = response.satuan
        this.loading.page = false
        this.loading.table = false
      } catch (error) {
        this.loading.page = false
        console.log(error);
        this.displayMessageValue("error-basic", error);
      }
    },
    setubah(){
      this.mode = "Ubah"
      this.inputVisible = false
    },
    save(){
      this.$refs.form.validate((valid) => {
        
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        const payload = {
          tlc: this.tlc,
          fasilitas: this.form.fasilitas,
          type_fasilitas: null,
          nilai_fasilitas: null,
          satuan: this.form.satuan,
          is_dpp: this.form.is_dpp,
        }
        
        const data = this.dataSource.listFasilitas.find((index) => index.option == this.form.fasilitas);
        if(data){
          payload.type_fasilitas = data.keterangan
          if(this.inputVisible && this.form.nilai_fasilitas){
            payload.nilai_fasilitas = this.form.nilai_fasilitas
            // payload.satuan = 'Rp'
          }
        }

        this.loading.save = true
        this.asyncAxiosPost("Master_karyawan/fasilitas", "application/json", this.getAuth, payload)
        .then(() => {
          this.displayMessage("success-save");
          this.loading.save = false
          this.mode = 'View'
          this.form.fasilitas = null
          this.form.nilai_fasilitas = null
          this.form.satuan = null
          this.form.is_dpp = "0"
          this.loading.table = true
          this.fetchData()
        })
        .catch((err) => {
          console.log(err);
          this.displayMessageValue("error-basic", err);
          this.loading.save = false
        });
      })
    },

    remove(id){
      const that = this
      const params = {
        tlc: this.tlc,
        id_fasilitas: id
      }
      this.$confirm({
        title: "Apakah anda yakin untuk hapus data ini?",
        content: '',
        okText: 'Ya',
        okType: 'danger',
        cancelText: 'Tidak',
        onOk() {
          that.loading.table = true
          that.asyncAxiosDelete("Master_karyawan/fasilitas", "application/json", that.getAuth,
          params)
          .then(() => {
            that.displayMessage("success-delete");
            that.loading.save = false
            that.mode = 'View'
            that.fetchData()
          })
          .catch((err) => {
            console.log(err);
            that.displayMessageValue("error-basic", err);
            that.loading.table = false
          });
        },
        onCancel() { },
      });
    },

    rupiahFormatter(value) {
      if (value === undefined || value === null || value === '') return ''
      // value bisa number atau string "1234567"
      const num = String(value).replace(/\D/g, '')
      if (!num) return ''
      // tambahin thousand separator '.'
      return 'Rp ' + num.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    rupiahParser(displayValue) {
      if (!displayValue && displayValue !== 0) return undefined
      // buang semua non-digit
      const digits = String(displayValue).replace(/\D/g, '')
      // return number (InputNumber menyimpan ini sebagai nilai)
      return digits === '' ? undefined : Number(digits)
    },

    onSelectItem(e) {
      if(e){
        const data = this.dataSource.listFasilitas.find((index) => index.option == e);
        if(data.keterangan == 'Nilai'){
          this.inputVisible = true
        }else {
          this.inputVisible = false
        }
      }
    }
    
  }
}
</script>